import { ReactElement, ReactNode } from 'react';
import { Tooltip, TooltipProps } from '@mui/material';
import { Typography } from './typography/typography';

export interface DualLineTooltipProps extends Omit<TooltipProps, 'title'> {
  title: string;
  body?: string | ReactNode;
  children: ReactElement;
}

export const DualLineTooltip = ({
  title,
  body,
  children,
  enterDelay = 500,
  placement = 'top-start',
  arrow = true,
  ...tooltipProps
}: DualLineTooltipProps) => {
  const tooltipText = getTooltipText(title, body);

  return (
    <Tooltip
      title={tooltipText}
      enterDelay={enterDelay}
      placement={placement}
      arrow={arrow}
      {...tooltipProps}
    >
      {children}
    </Tooltip>
  );
};

const getTooltipText = (title: string, body?: string | ReactNode) => {
  if (!body) return title;

  return (
    <div>
      <Typography.Title>{title}</Typography.Title>
      <Typography.Caption component="div" sx={{ color: 'primary.contrastText' }}>
        {body}
      </Typography.Caption>
    </div>
  );
};
